export const all = ['chat']
export const detail = (chatId: number) => [...all, chatId]
export const list = ['tripChats']

export const itinerary = ['itinerary']
export const itineraryDetail = (chatId: number) => [...itinerary, chatId]
